import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/common/authentication.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  StorageKey,
  StorageService,
} from '../../services/common/storage.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent {
  id: any;
  NotificationList: any;
  notificationCount: number = 0;
  UserType: any;
  isLoggedIn = false;
  showNotifications: boolean = false;
  private timeoutId: any;
  currentYear: number

  @ViewChild('notificationPanel') notificationPanel!: ElementRef;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private url: ApiUrlHelper,
    private storageService: StorageService,
    private apiservice: ApiService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private toastr: ToastrService
  ) {}
  
  ngAfterViewInit() {
    if (this.storageService.getTokenData().ringCentralPermission) {
      setTimeout(() => {
        let body = document.getElementsByTagName('body')[0];
        // let script = document.createElement('script');
        // script.type = 'text/javascript';
        // script.id = 'sidebar-script';
        // script.src = 'assets/pro-sidebar-template/main.js';
        // body.appendChild(script);

        var clientId = '7sIwuDt5Kz4d9e1wLvRy91';
        var appServer = 'https://platform.ringcentral.com';
        let ringScript = document.createElement('script');
        ringScript.type = 'text/javascript';
        ringScript.id = 'ringcentral-script';
        // ringScript.src = 'https://ringcentral.github.io/ringcentral-embeddable/adapter.js';
        ringScript.src =
          'https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/adapter.js' +
          '?clientId=' +
          clientId +
          '&appServer=' +
          appServer;
        body.appendChild(ringScript);
      }, 100);
      window.addEventListener('message', (e) => {
        const data = e.data;
        if (data) {
          switch (data.type) {
            case 'rc-login-status-notify':
              // get login status from widget
              // console.log('rc-login-status-notify:', data.loggedIn, data.loginNumber);
              if (
                data.loggedIn &&
                data.loginNumber != null &&
                data.loginNumber !== undefined
              ) {
                // Normalize phone number for comparison
                const loginNumber = this.normalizePhone(
                  data.loginNumber.split('*')[0]
                );
                // const actualNumber = this.normalizePhone('+18456823067');
                const actualNumber = this.normalizePhone(
                  this.storageService.getTokenData().ringCentralContact
                );
                // console.log('actualNumber:', actualNumber, 'loginNumber:', loginNumber);
                if (loginNumber === actualNumber) {
                  // Valid user
                } else {
                  this.toastr.error(
                    'You are not authorized to use ringcentral using ' +
                      loginNumber +
                      ' number.'
                  );
                  (window as any).RCAdapter.logoutUser();
                }
              }
              break;
            default:
              break;
          }
        }
      });
    }
    // setTimeout(() => {
    //   let body = document.getElementsByTagName('body')[0];
    //   let script = document.createElement('script');
    //   script.type = 'text/javascript';
    //   script.id = 'sidebar-script';
    //   script.src = 'assets/pro-sidebar-template/main.js';
    //   body.appendChild(script);
    // }, 100);
    // <script>
    //   (function () {
    //     var rcs = document.createElement("script");
    //     var clientId = "7sIwuDt5Kz4d9e1wLvRy91";
    //     var appServer = "https://platform.devtest.ringcentral.com"
    //     rcs.src = "https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/adapter.js?clientId=" + clientId + "&=appServer=" + appServer;
    //     var rcs0 = document.getElementsByTagName("script")[0];
    //     rcs0.parentNode.insertBefore(rcs, rcs0);
    //   })();
    // </script>
  }

  ngOnInit() {
    if (this.authService.isTokenValid()) {
      this.isLoggedIn = true;
      this.UserType = this.storageService.getTokenData().UserTypeId;
      this.id =
        this.UserType == 1 ? this.storageService.getTokenData().UserId : 0;
    }
    this.getNotificationList();
    this.timeoutId = setInterval(() => this.getNotificationList(), 120000);
    this.currentYear = new Date().getFullYear();
  }

  ngOnDestroy() {
    const script = document.getElementById('sidebar-script');
    if (script) {
      script?.parentNode?.removeChild(script);
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/admin/login']);
  }
  getNotificationList() {
    const obj = {
      pageNumber: 1,
      pageSize: 3,
      orderBy: '',
      sortOrder: '',
      search: '',
    };

    const apiUrl = this.url.apiUrl.notification.getNotificationList;

    this.apiservice.doPost(apiUrl, obj).subscribe({
      next: (data) => {
        if (data.Success) {
          this.NotificationList = data.Data;
          this.notificationCount =
            this.NotificationList.length > 0
              ? this.NotificationList[0]?.UnreadCount
              : 0;
        }
      },
      error: () => {
        this.spinner.hide();
        this.spinner.hide();
      },
    });
  }

  showNotification() {
    this.showNotifications = !this.showNotifications;
  }

  getNotificationLength(event: any) {
    this.getNotificationList();
  }

  normalizePhone(phone) {
    return phone.replace(/\D/g, '').slice(-10);
    // const cleaned = phone.replace(/\D/g, '');
    // // If number starts with +1 or 1 and has 11 digits → US
    // if (/^1?\d{10}$/.test(cleaned)) {
    //   return cleaned.slice(-10); // return last 10 digits
    // }
    // // If number has country code and is 11–15 digits (E.164 format)
    // if (/^\+?[1-9]\d{10,14}$/.test(phone)) {
    //   return phone.replace(/[^+\d]/g, ''); // keep + and digits
    // }
    // return null; // invalid format
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.notificationPanel?.nativeElement.contains(
      event.target
    );
    const clickedBellIcon = (event.target as HTMLElement).closest(
      '.notification-wrapper'
    );

    if (!clickedInside && !clickedBellIcon) {
      this.showNotifications = false;
    }
  }
}
